module.exports = __webpack_public_path__ + "img/bind-card-failed.dc597862.png";